<template>
  <div class="main">
    <template v-if="$store.state.isMobile == 2">
      <swiper class="swiper" :options="swiperOptions" ref="mySwiper">
        <!-- 第1个页面 -->
        <swiper-slide class="swiper-slideInn animate__animated animate__zoomIn">
          <HomeBanner :list="bannerList" class="swiper-no-swiping animate__animated animate__zoomIn" />
          <home_banner v-if="$store.state.editStatus === 0" :list="bannerList" @onReturn="getBanner(11)" />
        </swiper-slide>
        <!-- 公司简介 -->
        <swiper-slide class="swiper-slideInn heitvh animate__animated animate__zoomIn">
          <Introduction :inAnimation="inAnimation" :list="companyBriefIntroductionData" @animationend="inAnimation = false" class="swiper-no-swiping  animate__animated animate__zoomIn"></Introduction>
          <home_main v-if="$store.state.editStatus === 0" :type="1" :list="companyBriefIntroductionData" @onReturn="getcompanyBriefIntroduction" />
        </swiper-slide>
        <!-- 公司发展历程 -->
        <swiper-slide class="swiper-slideInn heitvh">
          <Development class="swiper-no-swiping animate__animated animate__zoomIn" :list="developHistoryList"></Development>
          <home_develop v-if="$store.state.editStatus === 0" :list="developHistoryList" @onReturn="getDevelopHistoryList" />
        </swiper-slide>
        <!-- 分子公司 -->
        <swiper-slide class="swiper-slideInn heitvh">
          <SubCompanies class="swiper-no-swiping " :list="subCompanieList"></SubCompanies>
          <home_dev v-if="$store.state.editStatus === 0" :type="1" :list="subCompanieList" @onReturn="getSubCompanieList" />
        </swiper-slide>
        <!-- 业务架构 -->
        <!-- <swiper-slide class="swiper-slideInn heitvh animate__animated animate__zoomIn">
          <div class="swiper-no-swiping swiper-containerInner " v-if="$store.state.language == 'Chinese'">
            <el-carousel height="100vh" :autoplay="false">
              <el-carousel-item v-for="(item, index) in homeDevRoadList" :key="index">
                <img style="width: 100%;height: calc(100% - 60px);margin-top: 60px;" :src="item.imgUrl" alt="">
              </el-carousel-item>
            </el-carousel>
            <home_devRoad v-if="$store.state.editStatus === 0" :type="1" :list="homeDevRoadList" @onReturn="getBanner(12)" />
          </div>
          <div class="swiper-no-swiping swiper-containerInner" v-else>
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="framework">
                  <div class="topTitle">
                    <div class="chinese">BUSINESS ARCHITECTURE</div>
                  </div>
                  <Tree :playTree="$store.state.playTree"></Tree>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="intelligence">
                  <div class="topTitle">
                    <div class="chinese">BUSINESS ARCHITECTURE</div>
                  </div>
                  <Cooperate :playCoo="$store.state.playCoo"></Cooperate>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </swiper-slide> -->
        <!-- 行业专题活动 -->
        <swiper-slide class="swiper-no-swiping swiper-slideInn heitvh">
          <div class="solution animate__animated animate__zoomIn">
            <div class="topTitle" v-if="$store.state.language == 'Chinese'">
              <div class="chinese">行业专题活动</div>
              <div class="english">FEATURED ACTIVITIES</div>
            </div>
            <div class="topTitle" v-else>
              <div class="chinese">FEATURED ACTIVITIES</div>
            </div>
            <SolutionCity :list="SolutionCityList"></SolutionCity>
          </div>
          <home_swiper style="z-index: 500000000;" v-if="$store.state.editStatus === 0" :type="1" :list="SolutionCityList" @onReturn="getBanner(13)" />
        </swiper-slide>
        <!-- 资讯动态 -->
        <swiper-slide class="swiper-no-swiping swiper-slideInn heitvh">
          <div class="news animate__animated animate__zoomIn">
            <div class="topTitle" v-if="$store.state.language == 'Chinese'">
              <div class="chinese">资讯动态</div>
              <div class="english">INFORMATION DYNAMIC</div>
            </div>
            <div class="topTitle" v-else>
              <div class="chinese">INFORMATION DYNAMIC</div>
            </div>
            <EditNews style="z-index: 500000000;transform: translateY(80px);" v-if="$store.state.editStatus === 0" @onReturn="() => { pageNum = 1; $refs.newsList.getNews() }" />
            <NewsShow class="totop" ref="newsList">
            </NewsShow>

          </div>

          <!-- <home_listEdit style="z-index: 500000000;" v-if="$store.state.editStatus === 0" :type="1" :list="bannerList" @onReturn="bannerDate" /> -->
        </swiper-slide>
        <swiper-slide class="swiper-no-swiping swiper-slideInn">
          <CopyRight></CopyRight>
        </swiper-slide>
      </swiper>
    </template>
    <template v-else>
      <MobileHome></MobileHome>
    </template>
  </div>
</template>
<script>
// var mySwiperInner = null;
import { banner } from "@/api/public"
import { getCompanyList, getDevelopHistoryList } from "@/api/home"
import { getCommonDataList } from '@/api/news.js'
import HomeBanner from "./components/homeBanner.vue"
import SolutionCity from "./components/SolutionCity.vue";
import NewsShow from "./components/NewsShow.vue";
import Tree from "./components/Tree.vue";
import Cooperate from "./components/Cooperate.vue";
import Introduction from "./components/Introduction.vue";
import Development from "./components/Development.vue";
import SubCompanies from "./components/SubCompanies.vue";
import Icon from "@/components/Icon.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import MobileHome from "./mobile/mobileHome.vue"
export default {
  name: "Home",
  components: {
    HomeBanner,
    swiper,
    swiperSlide,
    Icon,
    SolutionCity,
    Tree,
    Cooperate,
    Introduction,
    Development,
    SubCompanies,
    MobileHome,
    NewsShow
  },
  data () {
    let that = this;
    return {
      inAnimation: true,
      swiperOptions: {
        noSwiping: true, // 开启noSwiping
        noSwipingClass: 'swiper-no-swiping', // 设置noSwiping的类名
        speed: 800,
        grabCursor: true,
        direction: "vertical",
        slidesPerView: "auto",
        mousewheel: {},
        pagination: {
          el: ".swiper-pagination.page",
          clickable: true,
        },
        on: {
          init: function () {
            that.$swiperAnimateCache(this); //隐藏动画元素
            that.$swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function () {
            that.$store.commit('setHeaderIndex', this.activeIndex)
            that.Index = this.activeIndex;
            that.$swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          },
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;

            if (swiper.activeIndex === 4) {
              this.$store.dispatch("startTreeAnimation", true);
              this.$store.dispatch("startCooAnimation", true);
            } else {
              this.$store.dispatch("startTreeAnimation", false);
              this.$store.dispatch("startCooAnimation", false);
            }

          }
        },
      },
      Swiplist: [],
      mySwiperInner: null,
      bannerList: [],//banner数据
      subCompanieList: [],//分子公司数据
      developHistoryList: [],//发展历程数据
      SolutionCityList: [],//智慧城市解决方案
      homeDevRoadList: [],//业务构架
      companyBriefIntroductionData: [],//公司简介
    };
  },
  mounted () {

    if (this.$store.state.isMobile == 2) {
      this.getData()
    }

  },
  beforeDestroy () {
    if (this.$store.state.isMobile == 2) {
      document.removeEventListener("DOMMouseScroll", document.onmousewheel);
      window.onmousewheel = document.onmousewheel = ""; //IE/Opera/Chrome
      window.removeEventListener("resize", this.debounce(500));
    }

  },
  methods: {
    getData () {
      this.getBanner(11);
      this.getBanner(12);
      this.getBanner(13);
      this.getSubCompanieList();
      this.getDevelopHistoryList();
      this.getcompanyBriefIntroduction();


    },
    getBanner (type) {
      banner({ isRelease: this.$store.state.editStatus, type: type }).then(res => {

        //11：首页-主图，12：首页-业务架构，13：首页-智慧城市解决方案,为空查询全部
        if (type === 11) {
          this.bannerList = res.data;
        }
        if (type === 12) {
          this.homeDevRoadList = res.data;
        }
        if (type === 13) {
          this.SolutionCityList = res.data;
        }
      })
    },
    // 发展历程
    getDevelopHistoryList () {
      getDevelopHistoryList({ isRelease: this.$store.state.editStatus }).then(res => {
        this.developHistoryList = res.data;
      })
    },
    //公司简介
    getcompanyBriefIntroduction () {
      getCommonDataList({ commonData: 'company_brief_introduction', isRelease: this.$store.state.editStatus }).then(res => {
        this.companyBriefIntroductionData = JSON.parse(JSON.stringify(res.data));
      })
    },
    //分子公司
    getSubCompanieList () {
      getCompanyList({ isRelease: this.$store.state.editStatus }).then(res => {
        this.subCompanieList = res.data;
      })
    },
    pdfUrl (url) {

      let d = new Date()
      this.$router.push({ path: '/bdpdf', query: { name: url, t: d.getTime() } });
    },
    windowAddMouseWheel () {
      const self = this;
      const scrollFunc = function (e) {
        e = e || window.event;
        let wheelDelta = e.wheelDelta ? e.wheelDelta : -e.detail * 50;
        if (wheelDelta > 0) {
          self.flagIndex = 0;
        }
        if (wheelDelta < 0) {
          if (self.flagIndex == 1) {
            window.scrollTo(0, 300);
          }
          if (self.$refs.mySwiper.swiper.activeIndex === 4) {
            setTimeout(() => {
              self.flagIndex = 1;
            }, 500);
          }
        }
      };
      //给页面绑定滑轮滚动事件
      if (document.addEventListener) {
        //火狐使用DOMMouseScroll绑定
        document.addEventListener("DOMMouseScroll", scrollFunc, false);
      }
      //其他浏览器直接绑定滚动事件
      window.onmousewheel = document.onmousewheel = scrollFunc; //IE/Opera/Chrome
    },
    scrollTop () {
      // swiper跳转回第一页
      this.$refs.mySwiper.swiper.slideTo(0);
    },
    debounce (wait) {
      //定时器变量
      let timeout;
      return function () {
        //每次触发scrolle，先清除定时器
        clearTimeout(timeout);
        //指定多少秒后触发事件操作handler
        timeout = setTimeout(() => {
          location.reload();
        }, wait);
      };
    },

    bannerDate (v) {
      this.initMain('1')
      this.$nextTick(() => {
        this.bannerList = v
        this.$refs.homeBanner.bannerList = this.bannerList;
      })
    },

  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 767px) {
  .swiper {
    height: 100vh;
  }

  .main {
    .swiper-slideInn {
      height: auto;
      background-size: cover;
      width: 100%;
    }

    .heitvh {
      height: 100vh !important;

      > div {
        width: 100%;
        height: 100vh;
        background-size: cover;
      }
    }
  }

  .swiper-containerInner {
    .framework {
      // width: 100%;
      // height: 100vh;
      // background: url(../assets/img/framework.png) no-repeat center;
      // background-size: cover;
      .topTitle {
        padding: 10px;
        position: absolute;
        left: 50%;
        top: 7%;
        transform: translateX(-50%);
        z-index: 99;
        text-align: center;
      }
    }

    .intelligence {
      width: 100%;
      // height: 1080px;
      height: 100vh;
      background: url(../assets/img/intelligence_bg.png) no-repeat center;
      background-size: cover;

      .topTitle {
        padding: 10px;
        position: absolute;
        left: 50%;
        top: 7%;
        transform: translateX(-50%);
        z-index: 99;
        text-align: center;
      }
    }
  }

  .solution {
    background: url(../assets/img/classic/map_bg.jpg) no-repeat center;
    position: relative;
    z-index: 99;

    .topTitle {
      // padding-top: 60px;
      padding-top: 80px;
      color: #024094;
      text-align: center;
    }
  }

  .news {
    height: 100vh;
    background: url(../assets/img/news/news_bg.jpg) no-repeat bottom;

    .topTitle {
      // padding-top: 60px;
      padding-top: 80px;
      color: #024094;
      text-align: center;
    }

    .totop {
      position: relative;
      top: -35px;
    }
  }

  .zoomIn {
    transition: transform 0.5s;
  }

  .pic:hover {
    .mask {
      display: block;
    }

    .zoomIn {
      transform: scale(1.2);
    }
  }

  .mask {
    position: absolute;
    z-index: 9;
    visibility: visible;
    opacity: 1;
    width: 100%;
    height: 100%;
    content: '';
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 70%);
    display: none;
    top: auto;
    bottom: 0;
  }

  .swiper-slide-active {
    width: 100vw !important;
  }

  .gonggao {
    position: fixed;
    bottom: 110px;
    right: 0;
    z-index: 999;
    width: 182px;
    height: 100px;
  }
}

@media screen and (max-width: 767px) {
}

//移动端
</style>
